/**
 * The TextboxMessagesTemplate contains all the data needed to hydrate a Messages component
 *
 * @typedef {Object}      TextboxMessagesTemplate
 *
 * @property {String}     extraClasses      - Extra classes if needed
 */

export const defaultTextboxMessagesData = {
  extraClasses: ''
}

export const TextboxMessagesTemplate = (messages, wrapperId = '') => `
  <div ${wrapperId ? `id="${wrapperId}"` : ''} aria-live="polite">
    ${messages
      ? messages.map(message => `
        <div class="c-textbox__message">
          <i class="m-icon m-icon--warning-circle"></i>
          <span>${message}</span>
        </div>
      `).join('')
      : ''}
  </div>
`
